import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AuthStyles.css'; // Import custom CSS for auth components
import Landing from './Pages/Landing/Landing';
import Signup from './Pages/Signup/Signup';
import RegisterToken from './Components/RegisterToken/RegisterToken';
import Layout from './Components/Layout/Layout';
import Login from './Pages/Login/Login';
import Adbusiness from './Pages/Addbusiness/Adbusiness';
import Vendordasboard from './Pages/vendordashboard/Vendordashboard';
import Subscription from './Pages/Subscription/Subscription';
import Forgotpassword from './Pages/forgotpassword/Forgotpassword';
import ForgotPasswordOtp from './Pages/ForgotPasswordOTP/ForgotPasswordOTP';
import NewPassword from './Pages/NewPassword/NewPassword';
import PricingPlans from './Pages/PricingPlans/PricingPlans';
import Proceedtopayment from './Pages/Proceedtopayment/Proceedtopayment';
import VendorPayments from './Pages/VendorPayments/VendorPayments';
import PaymentSuccess from './Pages/PaymentSuccess/PaymentSuccess';
import AddService from './Pages/AddServicePage/AddService';
import VendorProfile from './Pages/vendorprofile/VendorProfile';
import VendorStatusPage from './Pages/VendorStatusPage/VendorStatusPage';
import { ProtectedRoute, AuthWrapper } from './AuthHandlers.js';

function App() {
  return (
    <Router>
      {/* Toast Container for notifications */}
      <ToastContainer 
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="register" element={<Signup />} />
        <Route path="vendor-verification" element={<RegisterToken />} />
        <Route path="forgot-password" element={<Forgotpassword />} />
        <Route path="forgot-password-otp-verification" element={<ForgotPasswordOtp />} />
        <Route path="new-password" element={<NewPassword />} />
        <Route path="login" element={<Login />} />

        
        {/* Protected routes inside Layout */}
        <Route 
          path="d/*" 
          element={
            <ProtectedRoute>
              <AuthWrapper>
                <Layout />
              </AuthWrapper>
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="vendor-dashboard" />} />
          <Route path="add-business" element={<Adbusiness />} />
          <Route path="vendor-dashboard" element={<Vendordasboard />} />
          <Route path="pricing-plans" element={<PricingPlans />} />
          <Route path="proceed-to-make-payment" element={<Proceedtopayment />} />
          <Route path="add-service" element={<AddService />} />
          <Route path="payment-success" element={<PaymentSuccess />} />
          <Route path="vendor-profile" element={<VendorProfile />} />
          <Route path="vendor-status" element={<VendorStatusPage />} />
        </Route>
    
        {/* Catch-all route redirects to landing */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;